import type { DetailedLead } from "common/types";

import useLead from "../../../datahooks/useLead";
import {
  formatExperienceStartAndEnd,
  getCompaniesFromWorkExperience,
} from "../../../utils";
import BaseLeadDetailTag from "./BaseLeadDetailTag";

export default function LeadCompanyTimeTag({
  leadKey,
  leadId,
  isLoading,
}: {
  leadId: string;
  leadKey: keyof Pick<DetailedLead, "current_experience" | "work_experience">;
  isLoading?: boolean;
}) {
  const { lead, isLoadingLead } = useLead({ profileId: leadId });

  const currentCompaniesNames = lead
    ? Object.keys(getCompaniesFromWorkExperience(lead.current_experience))
    : [];
  const companies = lead
    ? Object.entries(getCompaniesFromWorkExperience(lead[leadKey])).filter(
        ([name]) =>
          !!name &&
          (leadKey === "current_experience" ||
            !currentCompaniesNames.includes(name)),
      )
    : [];

  let extraItems: string[] = [];
  let label =
    leadKey === "current_experience"
      ? "No current company"
      : "No past companies";

  //make sure first company has a name
  if (companies.length) {
    const experiences = companies[0][1];
    const firstExperienceStart = experiences[experiences.length - 1].start_date;
    const lastExperienceEnd = experiences[0].end_date;

    label = formatExperienceStartAndEnd(
      firstExperienceStart,
      lastExperienceEnd,
    );

    extraItems = companies.slice(1).map(([, experiences]) => {
      const firstExperienceStart =
        experiences[experiences.length - 1].start_date;
      const lastExperienceEnd = experiences[0].end_date;

      return formatExperienceStartAndEnd(
        firstExperienceStart,
        lastExperienceEnd,
      );
    });
  }
  return (
    <BaseLeadDetailTag
      isLoading={isLoadingLead || isLoading}
      extraItems={extraItems}
    >
      {label}
    </BaseLeadDetailTag>
  );
}
